import { render, staticRenderFns } from "./QuestionFormSubmitted.vue?vue&type=template&id=0baad0e3&scoped=true"
import script from "./QuestionFormSubmitted.vue?vue&type=script&lang=js"
export * from "./QuestionFormSubmitted.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormSubmitted.vue?vue&type=style&index=0&id=0baad0e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baad0e3",
  null
  
)

export default component.exports